import type { ModuleDef } from "../types";
import { defineModule } from "./define";

export const ENGINES: ModuleDef[] = [
  defineModule({
    id: "thruster_chem_mk1",
    name: "Chem Thruster Mk.I",
    category: "engine",
    tier: 1,
    cells: { w: 1, h: 1 },
    sprite: "thruster_chem_mk1",
    stats: {
      mass: 100, hp: 60,
      tensile: 1_200_000_000,
      hardness: 0.7,
      powerIdleW: 150,
      thermalConductivity: 1.5,
      thermalEmissivity: 0.7,
      meltPointK: 1_670,
    },
    thrusters: [{
      dir: 0, thrustN: 73_000,
      powerW: 300,
      heatW: 250_000,
      fuelBurnKgPerSec: 32,
      plumeLengthM: 56,
    }],
  }),
  defineModule({
    id: "rcs_quad",
    name: "RCS Quad",
    category: "thruster",
    tier: 1,
    cells: { w: 1, h: 1 },
    sprite: "rcs_quad",
    stats: {
      mass: 80, hp: 40,
      tensile: 1_200_000_000,
      hardness: 0.65,
      powerIdleW: 80,
      thermalConductivity: 1.5,
      thermalEmissivity: 0.7,
      meltPointK: 1_670,
    },
    thrusters: [
      { dir: 0, thrustN: 6_000, powerW: 50, heatW: 20_000, fuelBurnKgPerSec: 2.0,
        plumeLengthM: 14 },
      { dir: 1, thrustN: 6_000, powerW: 50, heatW: 20_000, fuelBurnKgPerSec: 2.0,
        plumeLengthM: 14 },
      { dir: 2, thrustN: 6_000, powerW: 50, heatW: 20_000, fuelBurnKgPerSec: 2.0,
        plumeLengthM: 14 },
      { dir: 3, thrustN: 6_000, powerW: 50, heatW: 20_000, fuelBurnKgPerSec: 2.0,
        plumeLengthM: 14 },
    ],
  }),
];
